import React from 'react';
import { Table } from 'antd';
import moment from 'moment';

const EntriesTable = ({ entries }) => {
    const columns = [
        { title: 'Name', dataIndex: 'paperName', key: 'paperName' },
        { title: 'UUID', dataIndex: 'paperUuid', key: 'paperUuid' },
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text) => moment(text).format('MMMM Do YYYY, h:mm:ss a')
        },
    ];

    return (
        <Table columns={columns} dataSource={entries} rowKey="uuid" />
    );
};

export default EntriesTable;
